import { Collapse, Skeleton } from 'antd';
import type { BtlApplication } from '@api/btlApplicationForm/types';
import { ApplicantsSummary } from '@pages/BtlApplicationFormPage/CaseSummary/ApplicantsSummary';
import { FinancingAndPropertySummary } from '@pages/BtlApplicationFormPage/CaseSummary/FinancingAndPropertySummary';
import { useIntl } from 'react-intl';
import { OoProductSummary } from './OoProductSummary';

interface CaseOverviewProps {
  case?: BtlApplication;
  isLoading: boolean;
  canAccessHppPages?: boolean;
}

export function CaseOverview({ case: caseData, isLoading, canAccessHppPages }: CaseOverviewProps) {
  const { formatMessage } = useIntl();

  const sections = [
    {
      id: 'FINANCING_AND_PROPERTY',
      Content: () => <FinancingAndPropertySummary data={caseData} variant='oo' />,
      sectionTitle: formatMessage({ id: 'btlApplicationForm.FINANCING_AND_PROPERTY.label' }),
    },
    {
      id: 'APPLICANTS',
      Content: () => <ApplicantsSummary data={caseData} />,
      sectionTitle: formatMessage({ id: 'btlApplicationForm.APPLICANTS.label' }),
    },
    ...(canAccessHppPages
      ? [
          {
            id: 'PRODUCT',
            Content: () => <OoProductSummary caseData={caseData} />,
            sectionTitle: formatMessage({ id: 'ooApplicationForm.PRODUCT.label' }),
          },
        ]
      : []),
  ];

  return (
    <Collapse defaultActiveKey={sections.map((_, index) => String(index))}>
      {sections.map(({ id, Content, sectionTitle }, index) => (
        <Collapse.Panel header={sectionTitle} key={index} className={'[&_.ant-collapse-header]:items-center!'}>
          <Skeleton loading={isLoading} active>
            <Content key={id} />
          </Skeleton>
        </Collapse.Panel>
      ))}
    </Collapse>
  );
}
